// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3e-GU","productName":"Table_productName__1U_qC"};